// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"sJzeS","rc-tabs-tab":"r8ksl","rc-tabs-tab-active":"b5Qxc","tip":"K-viu","tip-label":"LpvJs","tip-group":"Tye-1","toppingAmountModifierItem":"US2RA"};